import NosotrosHero from '@/pages/nosotros/components/NosotrosHero';
import MissionBanner from '@/pages/nosotros/components/MissionBanner';
import Stats from '@/pages/home/components/Stats';
import ExpertiseBanner from '@/pages/nosotros/components/ExpertiseBanner';
import Testimonials from '@/pages/home/components/Testimonials';

export default function Nosotros() {
  return (
    <main className="min-h-screen bg-background-50">
      <NosotrosHero />
      <Stats />
      <MissionBanner />
      <ExpertiseBanner />
      <Testimonials />
    </main>
  );
}